/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { BoardShorts, Drawstring, LeftLeg, LeftThighBand, PartsWithDesign, RightLeg, RightThighBand, Shorts, SunlifeShorts, SwimShorts, Waistband } from './model/index.js';
export const constants = {
    SwimShorts: {
        $standardPrice: 240,
        $customizationSurcharge: 10,
        $thighBandOffsetY: -170
    },
    BoardShorts: {
        $standardPrice: 250,
        $customizationSurcharge: 10,
        $thighBandOffsetY: -210
    },
    Shorts: {
        $materialBaseProperties: {
            texture: {
                fileUrl: 'models/swim-shorts.glb',
                materialName: 'WaistbandMaterial',
                color: '#ffffff',
                textureUrl: null,
                repeatX: 0,
                repeatY: 0,
                offsetX: 0,
                offsetY: 0
            },
            color: {
                fileUrl: 'models/swim-shorts.glb',
                materialName: 'WaistbandMaterial',
                color: '#ffffff',
                textureUrl: null,
                repeatX: 0,
                repeatY: 0,
                offsetX: 0,
                offsetY: 0
            }
        },
        $collections: [
            {
                type: 'colors',
                key: 'solid',
                name: 'Solid',
                thumbnailUrl: '/swatches/solid.png',
                designs: [
                    {
                        name: 'Black',
                        key: 'black',
                        swatch: '#000000',
                        material: '#222222',
                        stitches: '#0c0c0c',
                        stitchesColorName: 'Black',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'White',
                        key: 'white',
                        swatch: '#ffffff',
                        material: '#ffffff',
                        stitches: '#f6f6f4',
                        stitchesColorName: 'White',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Red',
                        key: 'red',
                        swatch: '#ff0000',
                        material: '#ff0000',
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Phthalo Blue',
                        key: 'phthaloBlue',
                        swatch: '#001489',
                        material: '#001489',
                        stitches: '#374977',
                        stitchesColorName: 'Wedgewood Blue',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Persian Green',
                        key: 'persianGreen',
                        swatch: '#00b08b',
                        material: '#00b08b',
                        stitches: '#2a6670',
                        stitchesColorName: 'Teal 1',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Neon Blue',
                        key: 'neonBlue',
                        swatch: '#10069f',
                        material: '#10069f',
                        stitches: '#4b2f79',
                        stitchesColorName: 'Lt Imperial',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Blue',
                        key: 'blue',
                        swatch: '#0000ff',
                        material: '#0000ff',
                        stitches: '#374977',
                        stitchesColorName: 'Wedgewood Blue',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Space Cadet',
                        key: 'spaceCadet',
                        swatch: '#141b4d',
                        material: '#141b4d',
                        stitches: '#222a49',
                        stitchesColorName: 'Navy #1',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Dark Powder Blue',
                        key: 'darkPowderBlue',
                        swatch: '#0033a0',
                        material: '#0033a0',
                        stitches: '#374977',
                        stitchesColorName: 'Wedgewood Blue',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Columbia Blue',
                        key: 'columbiaBlue',
                        swatch: '#c8d8eb',
                        material: '#c8d8eb',
                        stitches: '#d2e2f4',
                        stitchesColorName: 'Lucerne Blue',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Maximum Blue Purple',
                        key: 'maximumBluePurple',
                        swatch: '#a7a4e0',
                        material: '#a7a4e0',
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Blue Bell',
                        key: 'blueBell',
                        swatch: '#afa4ce',
                        material: '#afa4ce',
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Indigo',
                        key: 'indigo',
                        swatch: '#440099',
                        material: '#440099',
                        stitches: '#4b2f79',
                        stitchesColorName: 'Lt Imperial',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Deep Violet',
                        key: 'deepViolet',
                        swatch: '#370063',
                        material: '#370063',
                        stitches: '#4b2f79',
                        stitchesColorName: 'Lt Imperial',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Ultramarine Blue',
                        key: 'ultramarineBlue',
                        swatch: '#4d4dff',
                        material: '#4d4dff',
                        stitches: '#374977',
                        stitchesColorName: 'Wedgewood Blue',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Deep Carmine Pink',
                        key: 'deepCarminePink',
                        swatch: '#ef3340',
                        material: '#ef3340',
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'RYB Red',
                        key: 'rybRed',
                        swatch: '#f93822',
                        material: '#f93822',
                        stitches: '#e26229',
                        stitchesColorName: 'Toboggan',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Candy Apple Red',
                        key: 'candyAppleRed',
                        swatch: '#fd0505',
                        material: '#fd0505',
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Boston University Red',
                        key: 'bostonUniversityRed',
                        swatch: '#cc0000',
                        material: '#cc0000',
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Awesome',
                        key: 'awesome',
                        swatch: '#ff1659',
                        material: '#ff1659',
                        stitches: '#d94f6b',
                        stitchesColorName: 'Coral Crush',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Wild Strawberry',
                        key: 'wildStrawberry',
                        swatch: '#ff3eb5',
                        material: '#ff3eb5',
                        stitches: '#cc8b95',
                        stitchesColorName: 'Old Rose',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Magic Potion',
                        key: 'magicPotion',
                        swatch: '#f8485e',
                        material: '#f8485e',
                        stitches: '#d94f6b',
                        stitchesColorName: 'Coral Crush',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Orchid Pink',
                        key: 'orchidPink',
                        swatch: '#f5b6cd',
                        material: '#f5b6cd',
                        stitches: '#cc8b95',
                        stitchesColorName: 'Old Rose',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Piggy Pink',
                        key: 'piggyPink',
                        swatch: '#f6deee',
                        material: '#f6deee',
                        stitches: '#f2f1e5',
                        stitchesColorName: 'Natural',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Pale Magenta-Pink',
                        key: 'paleMagentaPink',
                        swatch: '#f99fc9',
                        material: '#f99fc9',
                        stitches: '#cc8b95',
                        stitchesColorName: 'Old Rose',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Fuchsia',
                        key: 'fuchsia',
                        swatch: '#ff10f0',
                        material: '#ff10f0',
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Munsell Green',
                        key: 'munsellGreen',
                        swatch: '#00ab84',
                        material: '#00ab84',
                        stitches: '#3f7b3a',
                        stitchesColorName: 'Green',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Jungle Green',
                        key: 'jungleGreen',
                        swatch: '#279989',
                        material: '#279989',
                        stitches: '#2a6670',
                        stitchesColorName: 'Teal 1',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Pale Robin Egg Blue',
                        key: 'paleRobinEggBlue',
                        swatch: '#a1d6ca',
                        material: '#a1d6ca',
                        stitches: '#d2e2f4',
                        stitchesColorName: 'Lucerne Blue',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Pearl Aqua',
                        key: 'pearlAqua',
                        swatch: '#7ae1bf',
                        material: '#7ae1bf',
                        stitches: '#2a6670',
                        stitchesColorName: 'Teal 1',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Green',
                        key: 'lightGreen',
                        swatch: '#90ee90',
                        material: '#90ee90',
                        stitches: '#c8d865',
                        stitchesColorName: 'Hot Lime',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Kelly Green',
                        key: 'kellyGreen',
                        swatch: '#00b140',
                        material: '#00b140',
                        stitches: '#3f7b3a',
                        stitchesColorName: 'Green',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'La Salle Green',
                        key: 'laSalleGreen',
                        swatch: '#007a33',
                        material: '#007a33',
                        stitches: '#25582c',
                        stitchesColorName: 'Spanish Manchu',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Vivid Orange',
                        key: 'vividOrange',
                        swatch: '#ff5e00',
                        material: '#ff5e00',
                        stitches: '#e26229',
                        stitchesColorName: 'Toboggan',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Portland Orange',
                        key: 'portlandOrange',
                        swatch: '#ff5c39',
                        material: '#ff5c39',
                        stitches: '#e26229',
                        stitchesColorName: 'Toboggan',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Orange-Yellow',
                        key: 'orangeYellow',
                        swatch: '#ffb81c',
                        material: '#ffb81c',
                        stitches: '#f5b82a',
                        stitchesColorName: 'Bright Yellow',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Platinum',
                        key: 'platinum',
                        swatch: '#e6e6e6',
                        material: '#e6e6e6',
                        stitches: '#9b9a99',
                        stitchesColorName: 'Silver',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Gray',
                        key: 'lightGray',
                        swatch: '#d3d3d3',
                        material: '#d3d3d3',
                        stitches: '#9b9a99',
                        stitchesColorName: 'Silver',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Silver',
                        key: 'lightSilver',
                        swatch: '#d9d9d6',
                        material: '#d9d9d6',
                        stitches: '#9b9a99',
                        stitchesColorName: 'Silver',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Chinese Silver',
                        key: 'chineseSilver',
                        swatch: '#c8c9c7',
                        material: '#c8c9c7',
                        stitches: '#9b9a99',
                        stitchesColorName: 'Silver',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Spanish Gray',
                        key: 'spanishGray',
                        swatch: '#97999b',
                        material: '#97999b',
                        stitches: '#9b9a99',
                        stitchesColorName: 'Silver',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Sonic Silver',
                        key: 'sonicSilver',
                        swatch: '#75787b',
                        material: '#75787b',
                        stitches: '#9b9a99',
                        stitchesColorName: 'Silver',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: "Davy's Grey",
                        key: 'davysGrey',
                        swatch: '#53565a',
                        material: '#53565a',
                        stitches: '#9b9a99',
                        stitchesColorName: 'Silver',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Onyx',
                        key: 'onyx',
                        swatch: '#353935',
                        material: '#353935',
                        stitches: '#0c0c0c',
                        stitchesColorName: 'Black',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Dark Charcoal',
                        key: 'darkCharcoal',
                        swatch: '#2d2c2f',
                        material: '#2d2c2f',
                        stitches: '#0c0c0c',
                        stitchesColorName: 'Black',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Corn',
                        key: 'corn',
                        swatch: '#f6eb61',
                        material: '#f6eb61',
                        stitches: '#eeeb9b',
                        stitchesColorName: 'Lime Fizz',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Middle Yellow',
                        key: 'middleYellow',
                        swatch: '#ffe900',
                        material: '#ffe900',
                        stitches: '#f5b82a',
                        stitchesColorName: 'Bright Yellow',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Magic Mint',
                        key: 'magicMint',
                        swatch: '#b3eecb',
                        material: '#b3eecb',
                        stitches: '#c8d865',
                        stitchesColorName: 'Hot Lime',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Pastel Orange',
                        key: 'pastelOrange',
                        swatch: '#ffaa4d',
                        material: '#ffaa4d',
                        stitches: '#e8942e',
                        stitchesColorName: 'Zinnia',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Begonia',
                        key: 'begonia',
                        swatch: '#ff7276',
                        material: '#ff7276',
                        stitches: '#ee9c9d',
                        stitchesColorName: 'Shrimp',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Magnolia',
                        key: 'magnolia',
                        swatch: '#f8f4ff',
                        material: '#f8f4ff',
                        stitches: '#f6f6f4',
                        stitchesColorName: 'White',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Mint Cream',
                        key: 'mintCream',
                        swatch: '#f5fffa',
                        material: '#f5fffa',
                        stitches: '#f6f6f4',
                        stitchesColorName: 'White',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Robin Egg Blue',
                        key: 'robinEggBlue',
                        swatch: '#00d2b3',
                        material: '#00d2b3',
                        stitches: '#2a6670',
                        stitchesColorName: 'Teal 1',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: "Crayola's Maize",
                        key: 'crayolasMaize',
                        swatch: '#ffc845',
                        material: '#ffc845',
                        stitches: '#e8942e',
                        stitchesColorName: 'Zinnia',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Pael Pink',
                        key: 'paelPink',
                        swatch: '#f5dadf',
                        material: '#f5dadf',
                        stitches: '#ee9c9d',
                        stitchesColorName: 'Shrimp',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Electric Blue',
                        key: 'electricBlue',
                        swatch: '#7df9ff',
                        material: '#7df9ff',
                        stitches: '#d2e2f4',
                        stitchesColorName: 'Lucerne Blue',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Yankees Blue',
                        key: 'yankeesBlue',
                        swatch: '#141e46',
                        material: '#141e46',
                        stitches: '#222a49',
                        stitchesColorName: 'Navy #1',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Teal Deer',
                        key: 'tealDeer',
                        swatch: '#8decb4',
                        material: '#8decb4',
                        stitches: '#2a6670',
                        stitchesColorName: 'Teal 1',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Folly',
                        key: 'folly',
                        swatch: '#ff084a',
                        material: '#ff084a',
                        stitches: '#d94f6b',
                        stitchesColorName: 'Coral Crush',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Ferrari Red',
                        key: 'ferrariRed',
                        swatch: '#ff2700',
                        material: '#ff2700',
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        defaultDrawstringColor: 'white'
                    }
                ]
            },
            {
                type: 'textures',
                key: 'bigSur',
                name: 'Big Sur',
                thumbnailUrl: '/swatches/polka-dot.png',
                designs: [
                    {
                        name: 'Aqua',
                        key: 'aquaBigSur',
                        texture: '/textures/Polkadot/AQUA_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#2a6670',
                        stitchesColorName: 'Teal 1',
                        thumbnailUrl: '/textures/Polkadot/AQUA_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Black',
                        key: 'blackBigSur',
                        texture: '/textures/Polkadot/BLACK_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#0c0c0c',
                        stitchesColorName: 'Black',
                        thumbnailUrl: '/textures/Polkadot/BLACK_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Fuchsia',
                        key: 'fuchsiaBigSur',
                        texture: '/textures/Polkadot/FUCHSIA_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#ae3664',
                        stitchesColorName: 'Winter Apple',
                        thumbnailUrl: '/textures/Polkadot/FUCHSIA_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Light Gray',
                        key: 'lightGrayBigSur',
                        texture: '/textures/Polkadot/LTGREY_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#f2f1e5',
                        stitchesColorName: 'Natural',
                        thumbnailUrl: '/textures/Polkadot/LTGREY_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Navy',
                        key: 'navyBigSur',
                        texture: '/textures/Polkadot/NAVY_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#222a49',
                        stitchesColorName: 'Navy #1',
                        thumbnailUrl: '/textures/Polkadot/NAVY_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Purple',
                        key: 'purpleBigSur',
                        texture: '/textures/Polkadot/PURPLE_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        thumbnailUrl: '/textures/Polkadot/PURPLE_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Red',
                        key: 'redBigSur',
                        texture: '/textures/Polkadot/RED_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#ee9c9d',
                        stitchesColorName: 'Shrimp',
                        thumbnailUrl: '/textures/Polkadot/RED_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Royal Blue',
                        key: 'royalBlueBigSur',
                        texture: '/textures/Polkadot/ROYALBLUE_DOT_1_IN_8.10.png',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#222a49',
                        stitchesColorName: 'Navy #1',
                        thumbnailUrl: '/textures/Polkadot/ROYALBLUE_DOT_1_IN_8.10.png',
                        defaultDrawstringColor: 'white'
                    }
                ]
            },
            {
                type: 'textures',
                key: 'malibu',
                name: 'Malibu',
                thumbnailUrl: '/swatches/stripe-mini.png',
                designs: [
                    {
                        name: 'Black',
                        key: 'blackMalibu',
                        texture: '/textures/MiniStripe/BLACK_WHITE_MINI_STRIPE_REPEAT.jpg',
                        repeatX: 10,
                        repeatY: 10,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#0c0c0c',
                        stitchesColorName: 'Black',
                        thumbnailUrl: '/textures/MiniStripe/BLACK_WHITE_MINI_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Lavender',
                        key: 'lavenderMalibu',
                        texture: '/textures/MiniStripe/LAVENDER_WHITE_MINI_STRIPE_REPEAT.jpg',
                        repeatX: 10,
                        repeatY: 10,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        thumbnailUrl: '/textures/MiniStripe/LAVENDER_WHITE_MINI_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Light Blue',
                        key: 'lightBlueMalibu',
                        texture: '/textures/MiniStripe/LTBLUE_WHITE_MINI_STRIPE_REPEAT.jpg',
                        repeatX: 10,
                        repeatY: 10,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#d2e2f4',
                        stitchesColorName: 'Lucerne Blue',
                        thumbnailUrl: '/textures/MiniStripe/LTBLUE_WHITE_MINI_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Gray',
                        key: 'lightGrayMalibu',
                        texture: '/textures/MiniStripe/LTGRAY_WHITE_MINI_STRIPE_REPEAT.jpg',
                        repeatX: 10,
                        repeatY: 10,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#f2f1e5',
                        stitchesColorName: 'Natural',
                        thumbnailUrl: '/textures/MiniStripe/LTGRAY_WHITE_MINI_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Red',
                        key: 'redMalibu',
                        texture: '/textures/MiniStripe/RED_WHITE_MINI_STRIPE_REPEAT.jpg',
                        repeatX: 10,
                        repeatY: 10,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        thumbnailUrl: '/textures/MiniStripe/RED_WHITE_MINI_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Royal',
                        key: 'royalMalibu',
                        texture: '/textures/MiniStripe/ROYAL_WHITE_MINI_STRIPE_REPEAT.jpg',
                        repeatX: 10,
                        repeatY: 10,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#374977',
                        stitchesColorName: 'Wedgewood Blue',
                        thumbnailUrl: '/textures/MiniStripe/ROYAL_WHITE_MINI_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Teal',
                        key: 'tealMalibu',
                        texture: '/textures/MiniStripe/TEAL_WHITE_MINI_STRIPE_REPEAT.jpg',
                        repeatX: 10,
                        repeatY: 10,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#518aa7',
                        stitchesColorName: 'Medium Blue',
                        thumbnailUrl: '/textures/MiniStripe/TEAL_WHITE_MINI_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    }
                ]
            },
            {
                type: 'textures',
                key: 'monterey',
                name: 'Monterey',
                thumbnailUrl: '/swatches/stripe-medium.png',
                designs: [
                    {
                        name: 'Black',
                        key: 'blackMonterey',
                        texture: '/textures/MediumStripe/BLACK_MONTEREY_STRIPE_REPEAT.jpg',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#0c0c0c',
                        stitchesColorName: 'Black',
                        thumbnailUrl: '/textures/MediumStripe/BLACK_MONTEREY_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Jungle Green',
                        key: 'jungleGreenMonterey',
                        texture: '/textures/MediumStripe/JUNGLEGREEN_MONTEREY_STRIPE_REPEAT.jpg',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#518aa7',
                        stitchesColorName: 'Medium Blue',
                        thumbnailUrl: '/textures/MediumStripe/JUNGLEGREEN_MONTEREY_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Blue',
                        key: 'lightBlueMonterey',
                        texture: '/textures/MediumStripe/LTBLUE_MONTEREY_STRIPE_REPEAT.jpg',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#d2e2f4',
                        stitchesColorName: 'Lucerne Blue',
                        thumbnailUrl: '/textures/MediumStripe/LTBLUE_MONTEREY_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Gray',
                        key: 'lightGrayMonterey',
                        texture: '/textures/MediumStripe/LTGRAY_MONTEREY_STRIPE_REPEAT.jpg',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#f2f1e5',
                        stitchesColorName: 'Natural',
                        thumbnailUrl: '/textures/MediumStripe/LTGRAY_MONTEREY_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Pink',
                        key: 'pinkMonterey',
                        texture: '/textures/MediumStripe/PINK_MONTEREY_STRIPE_REPEAT.jpg',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#d94f6b',
                        stitchesColorName: 'Coral Crush',
                        thumbnailUrl: '/textures/MediumStripe/PINK_MONTEREY_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Purple',
                        key: 'purpleMonterey',
                        texture: '/textures/MediumStripe/PURPLE_MONTEREY_STRIPE_REPEAT.jpg',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        thumbnailUrl: '/textures/MediumStripe/PURPLE_MONTEREY_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Red',
                        key: 'redMonterey',
                        texture: '/textures/MediumStripe/RED_MONTEREY_STRIPE_REPEAT.jpg',
                        repeatX: 15,
                        repeatY: 15,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        thumbnailUrl: '/textures/MediumStripe/RED_MONTEREY_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    }
                ]
            },
            {
                type: 'textures',
                key: 'baha',
                name: 'Baha',
                thumbnailUrl: '/swatches/stripe-bold.png',
                designs: [
                    {
                        name: 'Aqua',
                        key: 'aquaBaha',
                        texture: '/textures/BoldStripe/AQUA_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#558cab',
                        stitchesColorName: 'Medium Blue',
                        thumbnailUrl: '/textures/BoldStripe/AQUA_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Black',
                        key: 'blackBaha',
                        texture: '/textures/BoldStripe/BLACK_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#0c0c0c',
                        stitchesColorName: 'Black',
                        thumbnailUrl: '/textures/BoldStripe/BLACK_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Blue',
                        key: 'blueBaha',
                        texture: '/textures/BoldStripe/BLUE_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#518aa7',
                        stitchesColorName: 'Medium Blue',
                        thumbnailUrl: '/textures/BoldStripe/BLUE_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Blue',
                        key: 'lightBlueBaha',
                        texture: '/textures/BoldStripe/LTBLUE_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#d2e2f4',
                        stitchesColorName: 'Lucerne Blue',
                        thumbnailUrl: '/textures/BoldStripe/LTBLUE_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Light Gray',
                        key: 'lightGrayBaha',
                        texture: '/textures/BoldStripe/LTGRAY_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#f2f1e5',
                        stitchesColorName: 'Natural',
                        thumbnailUrl: '/textures/BoldStripe/LTGRAY_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Light Pink',
                        key: 'lightPinkBaha',
                        texture: '/textures/BoldStripe/LTPINK_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#d94f6b',
                        stitchesColorName: 'Coral Crush',
                        thumbnailUrl: '/textures/BoldStripe/LTPINK_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Navy',
                        key: 'navyBaha',
                        texture: '/textures/BoldStripe/NAVY_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#374977',
                        stitchesColorName: 'Wedgewood Blue',
                        thumbnailUrl: '/textures/BoldStripe/NAVY_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Purple',
                        key: 'purpleBaha',
                        texture: '/textures/BoldStripe/PURPLE_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        thumbnailUrl: '/textures/BoldStripe/PURPLE_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Red',
                        key: 'redBaha',
                        texture: '/textures/BoldStripe/RED_BAHA_STRIPE_REPEAT.jpg',
                        repeatX: 7,
                        repeatY: 7,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        thumbnailUrl: '/textures/BoldStripe/RED_BAHA_STRIPE_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    }
                ]
            },
            {
                type: 'textures',
                key: 'nantucket',
                name: 'Nantucket',
                thumbnailUrl: '/swatches/ginghams.png',
                designs: [
                    {
                        name: 'Lavender',
                        key: 'lavenderNantucket',
                        texture: '/textures/Gingham/LAVENDER_GINGHAM_REPEAT.jpg',
                        repeatX: 100,
                        repeatY: 100,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#9b89c2',
                        stitchesColorName: 'Orchid',
                        thumbnailUrl: '/textures/Gingham/LAVENDER_GINGHAM_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Navy',
                        key: 'navyNantucket',
                        texture: '/textures/Gingham/NAVY_GINGHAM_REPEAT.jpg',
                        repeatX: 100,
                        repeatY: 100,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#222a49',
                        stitchesColorName: 'Navy #1',
                        thumbnailUrl: '/textures/Gingham/NAVY_GINGHAM_REPEAT.jpg',
                        defaultDrawstringColor: 'white'
                    },
                    {
                        name: 'Pink',
                        key: 'pinkNantucket',
                        texture: '/textures/Gingham/PINK_GINGHAM_REPEAT.jpg',
                        repeatX: 100,
                        repeatY: 100,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#ee9c9d',
                        stitchesColorName: 'Shrimp',
                        thumbnailUrl: '/textures/Gingham/PINK_GINGHAM_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Red',
                        key: 'redNantucket',
                        texture: '/textures/Gingham/RED_GINGHAM_REPEAT.jpg',
                        repeatX: 100,
                        repeatY: 100,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#b62926',
                        stitchesColorName: 'Fiery Red',
                        thumbnailUrl: '/textures/Gingham/RED_GINGHAM_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Seafoam',
                        key: 'seafoamNantucket',
                        texture: '/textures/Gingham/SEAFOAM_GINGHAM_REPEAT.jpg',
                        repeatX: 100,
                        repeatY: 100,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#9bc4a3',
                        stitchesColorName: 'Hot Lime',
                        thumbnailUrl: '/textures/Gingham/SEAFOAM_GINGHAM_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    },
                    {
                        name: 'Sky Blue',
                        key: 'skyBlueNantucket',
                        texture: '/textures/Gingham/SKYBLUE_GINGHAM_REPEAT.jpg',
                        repeatX: 100,
                        repeatY: 100,
                        offsetX: 0,
                        offsetY: 0,
                        stitches: '#d2e2f4',
                        stitchesColorName: 'Lucerne Blue',
                        thumbnailUrl: '/textures/Gingham/SKYBLUE_GINGHAM_REPEAT.jpg',
                        defaultDrawstringColor: 'black'
                    }
                ]
            }
        ]
    },
    Drawstring: {
        $availableColors: [
            {
                name: 'Black',
                key: 'black',
                swatch: '#000000',
                material: '#000000',
                stitches: '#000000'
            },
            {
                name: 'White',
                key: 'white',
                swatch: '#ffffff',
                material: '#ffffff',
                stitches: '#ffffff'
            },
            {
                name: 'Red',
                key: 'red',
                swatch: '#ff0000',
                material: '#ff0000',
                stitches: '#ff0000'
            },
            {
                name: 'Blue',
                key: 'blue',
                swatch: '#0000FF',
                material: '#0000FF',
                stitches: '#0000FF'
            },
            {
                name: 'Phthalo Blue',
                key: 'phthaloBlue',
                swatch: '#001489',
                material: '#001489',
                stitches: '#001489'
            },
            {
                name: 'Persian Green',
                key: 'persianGreen',
                swatch: '#00b08b',
                material: '#00b08b',
                stitches: '#00b08b'
            }
        ]
    }
};
const ShortsExpressions = [
    '$customProductTitle',
    '$customProductDescription',
    '$parts',
    '$leftLeg',
    '$rightLeg',
    '$leftThighBand',
    '$rightThighBand',
    '$waistband',
    '$drawstring',
    '$materialBaseProperties',
    '$collections'
];
const WithDesignExpressions = [
    '$collectionMap',
    '$selectedCollection',
    '$selectedDesign',
    '$collectionOptions',
    '$textureOptions',
    '$colorSwatches'
];
const DrawstringExpressions = [
    '$selectedColor',
    '$colorSwatches',
    '$availableColors'
];
const SwimShortsExpressions = [
    '$price',
    '$isMeshLiner',
    '$isCompressionLiner',
    '$leftLegMaterial',
    '$rightLegMaterial',
    '$leftThighBandMaterial',
    '$rightThighBandMaterial',
    '$waistbandMaterial',
    '$drawstringMaterialColor',
    '$stitchesMaterialColor',
    '$standardPrice',
    '$customizationSurcharge',
    '$thighBandOffsetY',
    '$violations'
];
const BoardShortsExpressions = [
    '$price',
    '$isMeshLiner',
    '$isCompressionLiner',
    '$leftLegMaterial',
    '$rightLegMaterial',
    '$leftThighBandMaterial',
    '$rightThighBandMaterial',
    '$waistbandMaterial',
    '$drawstringMaterialColor',
    '$stitchesMaterialColor',
    '$standardPrice',
    '$customizationSurcharge',
    '$thighBandOffsetY',
    '$violations'
];
const PartExpressions = [
    '$shorts'
];
export const $SwimShorts = new $DomainEntityReflection('SwimShorts', [
    ...SwimShortsExpressions,
    ...ShortsExpressions,
    ...WithDesignExpressions
]);
export const $BoardShorts = new $DomainEntityReflection('BoardShorts', [
    ...BoardShortsExpressions,
    ...ShortsExpressions,
    ...WithDesignExpressions
]);
export const $LeftLeg = new $DomainEntityReflection('LeftLeg', [
    ...WithDesignExpressions,
    ...PartExpressions
]);
export const $RightLeg = new $DomainEntityReflection('RightLeg', [
    ...WithDesignExpressions,
    ...PartExpressions
]);
export const $LeftThighBand = new $DomainEntityReflection('LeftThighBand', [
    ...WithDesignExpressions,
    ...PartExpressions
]);
export const $RightThighBand = new $DomainEntityReflection('RightThighBand', [
    ...WithDesignExpressions,
    ...PartExpressions
]);
export const $Waistband = new $DomainEntityReflection('Waistband', [
    ...WithDesignExpressions,
    ...PartExpressions
]);
export const $Drawstring = new $DomainEntityReflection('Drawstring', [
    ...DrawstringExpressions,
    ...PartExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    SwimShorts.type,
    BoardShorts.type,
    LeftLeg.type,
    RightLeg.type,
    LeftThighBand.type,
    RightThighBand.type,
    Waistband.type,
    Drawstring.type
]);
export const $SunlifeShorts = new EnhancedAliasReflection('$SunlifeShorts', [
    SwimShorts.type,
    BoardShorts.type
]);
export const $Shorts = new EnhancedAliasReflection('$Shorts', [
    ...SunlifeShorts.types
]);
export const $PartsWithDesign = new EnhancedAliasReflection('$PartsWithDesign', [
    LeftLeg.type,
    RightLeg.type,
    LeftThighBand.type,
    RightThighBand.type,
    Waistband.type
]);
export const $WithDesign = new EnhancedAliasReflection('$WithDesign', [
    ...Shorts.types,
    ...PartsWithDesign.types
]);
export const $Part = new EnhancedAliasReflection('$Part', [
    LeftLeg.type,
    RightLeg.type,
    LeftThighBand.type,
    RightThighBand.type,
    Waistband.type,
    Drawstring.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    ...Shorts.types
]);
export const $ThighBand = new EnhancedAliasReflection('$ThighBand', [
    LeftThighBand.type,
    RightThighBand.type
]);
export const $entityReflections = {
    SwimShorts: $SwimShorts,
    BoardShorts: $BoardShorts,
    LeftLeg: $LeftLeg,
    RightLeg: $RightLeg,
    LeftThighBand: $LeftThighBand,
    RightThighBand: $RightThighBand,
    Waistband: $Waistband,
    Drawstring: $Drawstring
};

//# sourceMappingURL=enhanced-model.js.map